import React from 'react';
import PropTypes from 'prop-types';

const ShareIcon = ({ title, url, classNames = '' }) => (
    <a
        className={`share share--facebook align-items-center d-flex ${classNames}`}
        style={{ width: '16px', cursor: 'pointer' }}
        data-toggle="popover"
        data-title={title}
        data-url={url}
    />
);

ShareIcon.propTypes = {
    title: PropTypes.string,
    url: PropTypes.string.isRequired,
    classNames: PropTypes.string,
};

export default ShareIcon;
